import React, { useRef } from 'react';

function Email({email}) {
    const segundosAnimacion = 3;
    const refCopiado = useRef(null);
    function handleClick() {
        try {
            navigator.clipboard.writeText(email);
            fadeOut();
        } catch (err) {
            alert("No es posible copiar el e-mail en el portapapeles desde tu navegador");
        }
    }
    function fadeOut(opacity = 1){
        refCopiado.current.style.opacity = opacity;
        setTimeout(() => {
            refCopiado.current.style.opacity = (refCopiado.current.style.opacity - 0.01).toFixed(2);
            if (refCopiado.current.style.opacity > 0){
                fadeOut(refCopiado.current.style.opacity);
            }
        }, (segundosAnimacion * 1000) / 100)
    }
    return (
        <span>
            <a href={`mailto:${email}`} target="_blank" rel="noreferrer">{email}</a>
            <i style={{paddingLeft: "8px"}} title='Copiar en el portapapeles'  className="arrowLink fa fa-clipboard" aria-hidden="true" onClick={handleClick}></i>
            {/* <span ref={refCopiado} style={{opacity: `${opacityAct.current}`, paddingLeft: "8px"}}>¡Copiado!</span> */}
            <span ref={refCopiado} style={{opacity: 0, paddingLeft: "8px"}} className="avisoProcesando">¡Copiado!</span>
        </span>
    );
}

export default Email;